// A list of appointments for an interpreter
import React, { useMemo, useRef, useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from "react-router-dom";
import { TextInput, Text, StyleSheet, useWindowDimensions } from 'react-native'
import { format, addDays, startOfWeek, endOfWeek, addWeeks, lastDayOfWeek, fromUnixTime } from 'date-fns';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Stack from 'react-bootstrap/Stack';
import Button from 'react-bootstrap/Button';
import { FaCalendarPlus, FaNotesMedical, FaSortAlphaDown, FaQuestionCircle, FaPhoneSquare, FaDog, FaMusic, FaMoon, FaSun, FaMapMarkedAlt, FaCheck, FaHospital, FaUserAstronaut, FaBullhorn, FaHeadSideCough, FaOpera, FaHandPointUp, FaScroll, FaIgloo, FaDownload, FaCar, FaSyncAlt, FaWalking, FaBell, FaQuestion, FaTrashAlt, FaLightbulb, FaHamsa, FaCalendarDay, FaGhost, FaClock, FaHospitalUser, FaHistory, FaUmbrellaBeach, FaUserAltSlash, FaRegWindowClose } from "react-icons/fa";
import {
  DataGrid, SelectCellFormatter,
  SelectColumn,
  textEditor,
  Column,
} from 'react-data-grid';

const Talker = () => {
  // Find out where to get data
  const apptsUrl = process.env.REACT_APP_APPTS_URL;
  const [isDev, setIsDev] = useState(apptsUrl.search('dev') > 0);
  const { tkr } = useParams();  // The the talker name
  document.title = `${tkr} CherryTalker`;
  const [talker, setTalker] = useState(tkr);
  const [curNow, setNow] = useState(new Date().toLocaleString());
  const [refreshInterval, setRefreshInterval] = useState(51000);
  const [alertTotal, setAlertTotal] = useState();
  const [tomTotal, setTomTotal] = useState();
  const [dayTotal, setDayTotal] = useState();
  const [showHelp, setShowHelp] = useState(false);
  const [brassRec, setBrassRec] = useState(null);
  const helpClose = () => setShowHelp(false);
  const [stat1, setStat1] = useState(null);
  const [stat2, setStat2] = useState(null);
  const [stat3, setStat3] = useState(null);
  const [showFlash, setShowFlash] = useState(false);

  const theDate = new Date().toLocaleString();
  const filterDateFormat = 'MM/dd/yyyy';
  const btnNormal = "btn btn-sm btn-outline-info";
  const btnDelay = "btn btn-sm btn-outline-danger superbutt";
  const btnActive = 'active ' + btnNormal;
  const btnOn = "btn btn-sm btn-outline-warning superbutt";
  const btnHdr = "btn btn-sm btn-outline-info microbutt";
  const btnHdrOn = "btn btn-sm btn-outline-warning microbutt";
  const btnHdrActive = 'active ' + btnHdr;
  const btnWait = 'active ' + btnOn;
  const btnOk = "btn btn-sm btn-outline-success superbutt";
  const btnGood = 'active ' + btnOk;
  const btnSelect = "btn btn-sm btn-outline-light";
  const btnSelectOn = 'active ' + btnNormal;
  const sortStyles = (active) => active ? btnActive : btnNormal;

  const [theme, setTheme] = useState('dark');
  // console.log('MasterPanel theme', theme);
  // const [themeClass, setThemethemeClass] = useState('rdg-dark');
  const [themeClass, setThemeClass] = useState('rdg-dark');

  const styles = createStyles(theme);
  // document.documentElement.style.cssText = "--color-scheme: dark";
  const remStyles = [styles.apptBase, styles.apptWaiting, styles.apptGood]
  const alertStyles = [styles.timeBase, styles.timeWaiting, styles.timeGood];
  // const waitToggle = [styles.apptBase, styles.apptWaiting]
  const [displaylist, setDisplay] = useState(null);

  // Sort
  var SortBlob = { active: 3, type: 'onDate' };
  const sortBlob = () => localStorage.getItem('SortBlob') ? JSON.parse(localStorage.getItem('SortBlob')) : SortBlob;
  const clickSort = (memactive, memtype) => {
    // Handle filter blob ops
    // build a fresh blob and save it
    setSortActive(memactive);
    SortBlob.active = memactive;
    setSortType(memtype);
    SortBlob.type = memtype;
    localStorage.setItem('SortBlob', JSON.stringify(SortBlob));
  }
  const [sortType, setSortType] = useState(sortBlob().type);
  const [sortActive, setSortActive] = useState(sortBlob().active);
  function sortField(val) {
    if (Number.isNaN(val)) { return val.toLowerCase() } else { return val }
  }

  // Org filter
  var OrgBlob = { active: false, select: false, orgs: [] };
  const orgBlob = () => localStorage.getItem('OrgBlob') ? JSON.parse(localStorage.getItem('OrgBlob')) : OrgBlob;
  const clickOrgs = (memactive, memselect, memclear) => {
    // Handle filter blob ops
    if (memclear) {
      setFilterOrgs([]);
      setOrgsActive(false);
      setOrgsSelect(false);
      localStorage.removeItem('OrgBlob');
    } else {
      // build a fresh blob and save it
      OrgBlob.orgs = filterOrgs;
      setOrgsActive(memactive);
      OrgBlob.active = orgsActive;
      setOrgsSelect(memselect);
      OrgBlob.select = orgsSelect;
      localStorage.setItem('OrgBlob', JSON.stringify(OrgBlob));
    }
    // OrgBlob(active: orgsActive, select: orgsSelect, orgs: filterOrgs)
  }
  const [orgs, setOrgs] = useState();
  const [filterOrgs, setFilterOrgs] = useState(orgBlob().orgs);
  const [orgsActive, setOrgsActive] = useState(orgBlob().active);
  const [orgsSelect, setOrgsSelect] = useState(orgBlob().select);

  // Location filter
  var LocBlob = { active: false, select: false, locs: [] };
  const locBlob = () => localStorage.getItem('LocBlob') ? JSON.parse(localStorage.getItem('LocBlob')) : LocBlob;
  const clickLocs = (memactive, memselect, memclear) => {
    // Handle filter blob ops
    if (memclear) {
      setFilterLocs([]);
      setLocsActive(false);
      setLocsSelect(false);
      localStorage.removeItem('LocBlob');
    } else {
      setLocsActive(memactive);
      LocBlob.active = locsActive;
      setLocsSelect(memselect);
      LocBlob.select = locsSelect;
      LocBlob.locs = filterLocs;
      localStorage.setItem('LocBlob', JSON.stringify(LocBlob));
    }
  }
  const [locs, setLocs] = useState([]);
  const [filterLocs, setFilterLocs] = useState(locBlob().locs);
  const [locsActive, setLocsActive] = useState(locBlob().active);
  const [locsSelect, setLocsSelect] = useState(locBlob().select);

  // Dates.. We create a number of date range beginning and end points
  const [filterToday, setToday] = useState(format(theDate, filterDateFormat));
  const [filterTomorrow, setTomorrow] = useState(format(addDays(theDate, 1), filterDateFormat));
  const [filter3rdDay, set3rd] = useState(format(addDays(theDate, 2), filterDateFormat));
  const [filter4thDay, set4th] = useState(format(addDays(theDate, 3), filterDateFormat));
  const [filter5thDay, set5th] = useState(format(addDays(theDate, 4), filterDateFormat));
  const [filterWeekBeg, setWeekBeg] = useState(format(startOfWeek(theDate), filterDateFormat));
  const [filterWeekEnd, setWeekEnd] = useState(format(endOfWeek(theDate), filterDateFormat));
  const [filterNextWeekBeg, setNextWeekBeg] = useState(format(startOfWeek(addWeeks(theDate, 1)), filterDateFormat));
  const [filterNextWeekEnd, setNextWeekEnd] = useState(format(endOfWeek(lastDayOfWeek(addWeeks(theDate, 1))), filterDateFormat));
  var DateBlob = { active: 3, beg: filterToday, end: filterTomorrow };
  const dateBlob = () => localStorage.getItem('DateBlob') ? JSON.parse(localStorage.getItem('DateBlob')) : DateBlob;
  const [filterActive, setActive] = useState(dateBlob().active);
  const [begDate, setBegDate] = useState(format(dateBlob().beg, filterDateFormat));
  const [endDate, setEndDate] = useState(format(dateBlob().end, filterDateFormat));
  const clickDate = (memactive, membeg, memend) => {
    // Handle filter blob ops
    setActive(memactive);
    DateBlob.active = memactive;
    setBegDate(membeg);
    DateBlob.beg = membeg;
    setEndDate(memend);
    DateBlob.end = memend;
    localStorage.setItem('DateBlob', JSON.stringify(DateBlob));
  }

  // reminder filter
  var RemBlob = { active: 0, rem24: 0, remDay: 0 };
  const remBlob = () => localStorage.getItem('RemBlob') ? JSON.parse(localStorage.getItem('RemBlob')) : RemBlob;
  const clickRems = (memactive, mem24, memToday, memclear) => {
    // Handle filter blob ops. Also handles remembering values in the browser LocalStorage
    if (memclear) {
      setRem24(0);
      setRemDay(0);
      setReminderActive(0);
      localStorage.removeItem('RemBlob');
    } else {
      setReminderActive(memactive);
      RemBlob.active = memactive;
      setRem24(mem24);
      RemBlob.rem24 = mem24;
      setRemDay(memToday);
      RemBlob.remDay = memToday;
      localStorage.setItem('RemBlob', JSON.stringify(RemBlob));
    }
  }
  const [rem24, setRem24] = useState(remBlob().rem24);
  const [remDay, setRemDay] = useState(remBlob().remDay);
  const [filterReminderActive, setReminderActive] = useState(remBlob().active);

  // Status
  var StatBlob = { active: 0, status: [] };
  const statBlob = () => localStorage.getItem('StatBlob') ? JSON.parse(localStorage.getItem('StatBlob')) : StatBlob;
  const clickStats = (memactive, memclear) => {
    window.scrollTo(0, 0)
    // Handle filter blob ops
    if (memclear) {
      setStatActive(0);
      localStorage.removeItem('StatBlob');
    } else {
      setStatActive(memactive);
      StatBlob.active = memactive;
      localStorage.setItem('StatBlob', JSON.stringify(StatBlob));
    }
  }
  const [filterStatActive, setStatActive] = useState(statBlob().active);

  // get Master List
  // const [masterlist, setMaster] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchMetrics();
    if (refreshInterval && refreshInterval > 0) {
      const interval = setInterval(refreshMaster, refreshInterval);
      return () => clearInterval(interval);
    }
  }, [refreshInterval, alertTotal, tomTotal, dayTotal]);

  const fetchMetrics = () => {
    // retrieve and then setData()
    // `${apptsUrl}scraperextracts`
    fetch(`${apptsUrl}scraperextracts?talker=${talker.replace(/ /g, '').toUpperCase()}`)
      .then(response => response.json())
      .then(data => {
        const orgArr = [];
        const locArr = [];
        const dataArr = [];
        var altoto = 0;
        var rem24toto = 0;
        var remDaytoto = 0;
        data.forEach((val) => {
          console.log('talker match', (val.interpreter[0] === 'Ma'), val.interpreter.length, val.interpreter, val.interpreter.replace(/ /g, '').toUpperCase());
          dataArr.push(val);
          if (!orgArr.includes(val.farmOrg)) {
            orgArr.push(val.farmOrg);
          }
          if (!locArr.includes(val.apptLoc.slice(0, 15))) {
            locArr.push(val.apptLoc.slice(0, 15));
          }
          altoto = altoto + val.alCount;
          rem24toto = rem24toto + (val.al24.val === 1 ? 1 : 0);
          remDaytoto = remDaytoto + (val.alToday.val === 1 ? 1 : 0);
        });
        setOrgs(orgArr);
        setLocs(locArr);
        setAlertTotal(altoto);
        setTomTotal(rem24toto);
        setDayTotal(remDaytoto);
        // setMaster(dataArr);
        setDisplay(dataArr);
      })
      .catch(error => console.error(error));
  }

  // Alert dosplay is controlled here
  const refreshMaster = () => {
    // update time
    setNow(format(new Date().toLocaleString(), 'eee h:mm:ss aaaa'));
    fetchMetrics();
  };

  const scrollTop = () => { window.scrollTo(0, 0); }

  //
  //
  // datagrid support
  //
  // This the the Grid Filter and Sort
  const selectedRows = () => {
    if (!displaylist) return [];
    return displaylist
      .sort((a, b) =>
      (sortField(a[sortType]) > sortField(b[sortType]) ? 1 :
        ((sortField(b[sortType]) > sortField(a[sortType])) ? -1 : 0)))
      .filter(appt => (
        ((appt.onDate >= begDate) && (appt.onDate <= endDate)) &&
        (!orgsActive || (orgsActive && filterOrgs && (Array.from(filterOrgs).includes(appt.farmOrg)))) &&
        (!locsActive || (locsActive && filterLocs && (Array.from(filterLocs).includes(appt.apptLoc.slice(0, 15)))))
      ));
  };

  const cellStatClass = (row) => {
    if (row.isLive === -1) {
      return 'apptInactive';
    }
    return undefined;
  };


  // Grid heading totals
  const summaryRows = useMemo(() => {
    var alTot = 0;
    var sayerTot = [];
    var dateTot = 0;
    var orgTot = [];
    var clientTot = [];
    var locTot = [];
    // Total accross all recs
    displaylist && displaylist.filter((r) => r.alCount).map((r) => (
      alTot = alTot + r.alCount
    ));
    // Total accros date range.
    displaylist && displaylist
      .filter((r) => ((r.onDate >= begDate) && (r.onDate <= endDate)))
      .forEach((r) => {
        !sayerTot.includes(r.interpreter) && sayerTot.push(r.interpreter);
        !clientTot.includes(r.apptClient) && clientTot.push(r.apptClient);
        !orgTot.includes(r.farmOrg) && orgTot.push(r.farmOrg);
        !locTot.includes(r.apptLoc.slice(0, 15)) && locTot.push(r.apptLoc.slice(0, 15));
        dateTot++;
      });
    return [
      {
        id: 'total_0',
        totalRecs: alTot,
        datesTotal: dateTot,
        totalSayers: sayerTot.length,
        totalClients: clientTot.length,
        totalRem24: displaylist ? displaylist.filter((r) => r.al24).length : 0,
        totalRemDay: displaylist ? displaylist.filter((r) => r.alToday).length : 0,
        totalEnRoute: displaylist ? displaylist.filter((r) => r.alEnRoute).length : 0,
        totalThere: displaylist ? displaylist.filter((r) => r.alThere).length : 0,
        totalPatient: displaylist ? displaylist.filter((r) => r.alPatient).length : 0,
        totalDone: displaylist ? displaylist.filter((r) => r.alDone).length : 0
      }
    ];
  }, [displaylist, begDate, endDate]);

  // DataGrid Column Definitions
  // This build the grid
  function getColumns(arg1, arg2) {
    return [
      {
        key: 'apptClient',
        name: 'Client',
        frozen: true,
        width: 250,
        minwidth: 250,
        renderSummaryCell({ row }) {
          return (
            <span>
              <button className={btnHdr} title="Sort by CLIENT NAME" onClick={() => clickSort(4, 'apptClient')}>
                <FaSortAlphaDown style={styles.btnHdr} />
              </button>&nbsp;
              {isDev ? <span className="runningman down">&nbsp;DEV</span> : <span className="runningman up">&nbsp;Live</span>}
              <br></br>
              <span style={styles.colTots}>T: {row.totalClients}&nbsp;&nbsp;&nbsp;
                &nbsp;{alertTotal > 0 ? <span style={styles.isFail}>&nbsp;&nbsp;{alertTotal}</span> : <span style={{ color: 'limegreen' }}>Nadalerts</span>}
              </span >
            </span>);
        },
        renderCell(props) {
          return (
            <span className="text-nowrap" title={props.row.apptClient} >
              {props.row.apptNotes &&
                <span><FaNotesMedical style={styles.btnHdr} title={props.row.apptNotes} />&nbsp;</span>}

              <Link className="text-nowrap" target='_blank' to={`/work/${props.row.recid}`}><FaHamsa />&nbsp;
                <span className="text-nowrap" style={styles.linktext}><span style={styles.nametext}>{props.row.apptClient}</span></span>
              </Link>
              {props.row.isRush === 'On'
                ? <span style={styles.rush} >&nbsp;RUSH</span>
                : <span>&nbsp;</span>
              }
              {props.row.apptNotes &&
                <span>&nbsp;&nbsp;<span style={styles.text}>{props.row.apptNotes}</span></span>}
            </span>
          );
        }
      },
      {
        key: 'al24', name: '24', frozen: true, width: 55, maxWidth: 120,
        renderSummaryCell({ row }) {
          return (tomTotal > 0 ? <span style={styles.isFail}>{tomTotal}</span> : <span></span>)
        },
        renderCell(props) {
          return (
            <>
              {props.row.al24 === 1 ? <span style={styles.failCell}>24</span> :
                props.row.rem24 ? <span style={alertStyles[props.row.remV24 ? props.row.remV24 : 0]}>{props.row.rem24}</span> : <span></span>}
            </>
          );
        }
      },
      {
        key: 'alToday', name: <FaCalendarDay />, frozen: true, width: 55, maxWidth: 120,
        renderSummaryCell({ row }) {
          return (dayTotal > 0 ? <span style={styles.isFail}>{dayTotal}</span> : <span></span>);
        },
        renderCell(props) {
          return (
            <>
              {props.row.alToday ? <FaCalendarDay style={styles.failCell} /> :
                props.row.remToday ? <span style={alertStyles[props.row.remVToday ? props.row.remVToday : 0]}>{props.row.remToday}</span> : <span></span>}
            </>
          );
        }
      },
      {
        key: 'alEnRoute', name: <FaCar />, frozen: true, width: 55, maxWidth: 120,
        renderSummaryCell({ row }) {
          return (<span style={styles.isFail}>{row.totalEnRoute > 0 && row.totalEnRoute}</span>);
        },
        renderCell(props) {
          return (
            <>
              {props.row.alEnRoute ? <FaCar style={styles.failCell} /> :
                props.row.statEnRoute ? <span style={styles.timeCell}>{props.row.statEnRoute}</span> : <span></span>}
            </>
          );
        }
      },
      {
        key: 'alThere', name: <FaHospitalUser />, frozen: true, width: 55, maxWidth: 120,
        renderSummaryCell({ row }) {
          return (<span style={styles.isFail}>{row.totalThere > 0 && row.totalThere}</span>);
        },
        renderCell(props) {
          return (
            <>
              {props.row.alThere ? <FaHospitalUser style={styles.failCell} /> :
                props.row.statThere ? <span style={styles.timeCell}>{props.row.statThere}</span> : <span></span>}
            </>
          );
        }
      },
      {
        key: 'alPatient', name: <FaHeadSideCough />, frozen: true, width: 55, maxWidth: 120,
        renderSummaryCell({ row }) {
          return (<span style={styles.isFail}>{row.totalPatient > 0 && row.totalPatient}</span>);
        },
        renderCell(props) {
          return (
            <>
              {props.row.alPatient ? <FaHeadSideCough style={styles.failCell} /> :
                (props.row.statWait || props.row.statWith) ? <span style={styles.timeCell}>{props.row.statWait || props.row.statWith}</span> : <span></span>}
            </>
          );
        }
      },
      {
        key: 'alDone', name: <FaUmbrellaBeach />, frozen: true, width: 55, maxWidth: 120,
        renderSummaryCell({ row }) {
          return (<span style={styles.isFail}>{row.totalDone > 0 && row.totalDone}</span>);
        },
        renderCell(props) {
          return (
            <>
              {props.row.alDone ? <FaUmbrellaBeach style={styles.failCell} /> :
                props.row.statComplete ? <span style={styles.timeCell}>{props.row.statComplete}</span> : <span></span>}
            </>
          );
        }
      },
      {
        key: 'onDate', name: 'Date', width: 120, frozen: true,
        cellClass(row) {
          return cellStatClass(row);
        },
        renderSummaryCell({ row }) {
          return (<span style={styles.colTots}><span>
            <button className={btnHdr} title="Sort by APPT TIME" onClick={() => clickSort(3, 'dateAppt')}>
              <FaSortAlphaDown />
            </button>&nbsp;
          </span >
            <br></br>
            T: {row.datesTotal}</span>);
        },
        renderCell(props) {
          return (
            <span className="text-nowrap" style={styles.text1} >{format(props.row.onDate, 'EEEEEE')}&nbsp;{format(props.row.onDate, 'MMM do')}
            </span>
          );
        }
      },
      {
        key: 'atWhen', name: 'When', width: 150, frozen: true, className: 'flex-nowrap',
        cellClass(row) {
          return cellStatClass(row);
        },
        renderSummaryCell() {
          return (<span><span>
            <button className={btnHdr} title="SCROLL UP" onClick={() => scrollTop()}><FaScroll /><FaHandPointUp /></button>&nbsp;
          </span >
            <br></br>
            {curNow}</span>);
        },
        renderCell(props) {
          return (
            <span className="text-nowrap" title={"ID:" + props.row.recid + " Days:" + props.row.ageDays + " Hrs:" + props.row.ageHours + " Mins:" + props.row.ageMins} style={styles.text1}>{props.row.atWhen}</span>
          );
        }
      },

      {
        key: 'apptLoc',
        name: 'Location',
        width: 350,
        renderSummaryCell() {
          return (<span className='text-nowrap' style={styles.text1}>
            <button className={btnHdr} title="Sort by APPT LOCATION" onClick={() => clickSort(5, 'apptLoc')}><FaSortAlphaDown style={styles.btnHdr} /></button>&nbsp;
            &nbsp; &nbsp;
            <button className={locsActive ? btnHdrActive : btnHdr} title="Select LOCATIONS" onClick={() => clickLocs(true, true, false)}><FaLightbulb /></button>&nbsp;
            <button className={locsActive ? btnHdrOn : btnHdr} title="Clear LOCATIONS" onClick={() => clickLocs(false, false, true)}><FaTrashAlt /></button>&nbsp;
          </span>);
        },
        renderCell(props) {
          return (
            <span title={props.row.apptLoc}>{props.row.apptLoc}</span>

          );
        }
      },
      {
        key: 'occID', name: 'Map', width: 50,
        renderSummaryCell() {
          return (<span>
            <button className={btnHdr} title="HELP" onClick={() => setShowHelp(true)}><FaQuestionCircle /></button>
          </span >
          )
        },
        renderCell(props) {
          return (
            <a target='_blank' rel='noopener noreferrer' href={"https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(props.row.apptAddr)}>Map</a>
          );
        }
      },
      {
        key: 'apptState', name: 'State', width: 70,
        cellClass(row) {
          return cellStatClass(row);
        }
      },
      {
        key: 'apptAddr', name: 'Address', width: 200, className: 'text-nowrap',
        renderSummaryCell() {
          return (<span>Address &nbsp; &nbsp; &nbsp;
            <button className={btnHdr} title="Sort by ADDRESS" onClick={() => clickSort(6, 'apptAddr')}><FaSortAlphaDown /></button>&nbsp;
          </span >
          )
        },
        renderCell(props) {
          return (
            <span className='text-nowrap' title={props.row.apptAddr} style={styles.nametext}>{props.row.apptAddr}</span>
          );
        }
      },
      {
        key: 'farmOrg', name: 'Org', width: 200, className: 'text-nowrap',
        renderSummaryCell() {
          return (<span>
            <button className={orgsActive ? btnHdrActive : btnHdr} title="Select ORGANIZATIONS" onClick={() => clickOrgs(true, true, false)}><FaLightbulb /></button>&nbsp;
            <button className={orgsActive ? btnHdrOn : btnHdr} title="Clear ORGANIZATIONS" onClick={() => clickOrgs(false, false, true)}><FaTrashAlt /></button>&nbsp;
          </span >
          )
        },
        renderCell(props) {
          return (
            <span className='text-nowrap' title={props.row.farmOrg} style={styles.nametext}>{props.row.farmOrg}</span>
          );
        }
      },
      {
        key: 'ageSecs', name: 'Age', width: 150,
        renderCell(props) {
          return (
            <span style={{ color: "lightgreen", fontSize: "0.8em" }}>Min: {props.row.ageMins}  Hrs: {props.row.ageHours}  Days: {props.row.ageDays}</span>
          );
        }
      },
    ];
  }

  return (
    <div>
      {displaylist ?
        <div>
          <div style={{ backgroundColor: "black" }} className="topLine1">
            <span style={{ color: "crimson", fontWeight: "bold" }}>&nbsp;&nbsp;Cherry Talker&nbsp;&nbsp;</span> [:{talker}:]&nbsp;&nbsp;&nbsp;
            <button className={btnHdr} title="REFRESH PAGE" onClick={() => window.location.reload()}><FaSyncAlt /></button>&nbsp;&nbsp;&nbsp;
            &nbsp;Day:&nbsp;
            <button className={1 === filterActive ? btnActive : btnNormal} title="View TODAY" onClick={() => clickDate(1, filterToday, filterToday)}>&nbsp;<FaCalendarDay />&nbsp;</button>&nbsp;
            <button className={2 === filterActive ? btnActive : btnNormal} title="View TOMORROW" onClick={() => clickDate(2, filterTomorrow, filterTomorrow)}><span className='sortWord'>{format(addDays(new Date(), 1).toLocaleString(), "eee")}</span><span className='sortIcon'>{format(addDays(new Date(), 1).toLocaleString(), "eeeeee")}</span></button>&nbsp;
            <button className={3 === filterActive ? btnActive : btnNormal} title="View TODAY and TOMORROW" onClick={() => clickDate(3, filterToday, filterTomorrow)}>Both</button>&nbsp;
            <button className={4 === filterActive ? btnActive : btnNormal} title="View DAY AFTER TOMORROW" onClick={() => clickDate(4, filter3rdDay, filter3rdDay)}><span className='sortWord'>{format(addDays(new Date(), 2).toLocaleString(), "eee")}</span><span className='sortIcon'>{format(addDays(new Date(), 2).toLocaleString(), "eeeeee")}</span></button>&nbsp;
            <button className={5 === filterActive ? btnActive : btnNormal} title="View DAY 4" onClick={() => clickDate(5, filter4thDay, filter4thDay)}><span className='sortWord'>{format(addDays(new Date(), 3).toLocaleString(), 'eee')}</span><span className='sortIcon'>{format(addDays(new Date(), 3).toLocaleString(), 'eeeeee')}</span></button>&nbsp;
            <button className={6 === filterActive ? btnActive : btnNormal} title="View DAY 5" onClick={() => clickDate(6, filter5thDay, filter5thDay)}><span className='sortWord'>{format(addDays(new Date(), 4).toLocaleString(), 'eee')}</span><span className='sortIcon'>{format(addDays(new Date(), 4).toLocaleString(), 'eeeeee')}</span></button>&nbsp;
            &nbsp;Week:&nbsp;
            <button className={7 === filterActive ? btnActive : btnNormal} title="Filter by THIS WEEK" onClick={() => clickDate(7, filterWeekBeg, filterWeekEnd)}>This</button>&nbsp;
            <button className={8 === filterActive ? btnActive : btnNormal} title="Filter by NEXT WEEK" onClick={() => clickDate(8, filterNextWeekBeg, filterNextWeekEnd)}>Next</button>&nbsp;
            &nbsp;&nbsp;&nbsp;<button className={btnOn} title='CLOSE' onClick={() => window.close()}><FaRegWindowClose /></button>

          </div>
          <DataGrid
            columns={getColumns(1, 2)}
            rows={selectedRows()}
            topSummaryRows={summaryRows}
            className={themeClass}
            defaultColumnOptions={{
              sortable: false,
              resizable: false
            }}
            style={{ paddingTop: '70px', height: '100vh' }}
          />

          <Offcanvas show={showHelp} className="mt-3" data-bs-theme="dark" placement='bottom'>
            <Offcanvas.Header className="sidebarright">
              <Offcanvas.Title>&nbsp;
                <Text style={styles.nametext}><FaQuestionCircle />&nbsp;&nbsp;Instructions for using the Cherry Talker</Text>
                &nbsp;&nbsp;&nbsp;&nbsp;<button className="btn btn-sm btn-outline-warning" onClick={helpClose}>Close</button>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body style={styles.text}>
              <div>
                <h4>The Cherry Talker Appointment  List</h4>
                <ul>
                  <li>You are here to work the list of appointments in Cherry Talker. Cherry Talker appointment tracking is made up of two pieces. This list and the appointment.
                  </li>
                  <li>You can look at different date ranges using the Day or Week. You cannot go back to previous weeks.
                    You cannot go beyond next week.
                  </li>
                  <li>
                    The list is refreshed about once a minute. Changes made in the appointments will appear in the list after the refresh automatically. You can also manually refresh the using the button <FaSyncAlt />.
                  </li>
                  <li>
                    To get the exact location of the Appointment, click on the Map link to open Google Maps.
                  </li>
                </ul>
              </div>
              <div>
                <h4>You do the following things with the list</h4>
                <ul>
                  <li>Sort (change the order of the list)</li>
                  <li>Filter (change the contents of the list). <br></br>
                    When you start to select a filter, the list goes empty. Appts that match your filter will appear as you select. If you decide to not use the filter, clear it and the list will come back.<br></br>
                    The Date filters can't be cleared. You must select a date range. The totals for the date range is in the column headings.
                  </li>
                  <li>Here are the icons and their meaning:<br></br>
                    <FaSyncAlt style={styles.btnHdr} />=Refresh the page.<br></br>
                    <FaSortAlphaDown style={styles.btnHdr} />=Sort by column.<br></br>
                    <FaScroll style={styles.btnHdr} /><FaHandPointUp style={styles.btnHdr} />=Scroll to Top.<br></br>
                    <FaLightbulb style={styles.btnHdr} />=Select entries for a Filter (Org, Location).<br></br>
                    <FaTrashAlt style={styles.btnHdr} />=Clear the Filter.<br></br>
                    <FaHamsa style={styles.btnHdr} />=Open the appointment in a new tab.<br></br>
                    <FaCalendarDay style={styles.btnHdr} />=Date of Appointment.<br></br>
                    <FaGhost style={styles.btnHdr} />=Deactivated. The Appt is cancelled and can no longer be updated.<br></br>
                    <FaOpera style={styles.btnHdr} />=Brass Ring. <br></br>
                  </li>
                </ul>
              </div>
              <div>
                <h4>For each Appt you have a Map button to open a tab to the Google Maps page for the Appt Location.</h4>
              </div>
            </Offcanvas.Body>
          </Offcanvas>
          {orgsSelect ?
            <Offcanvas show={orgsSelect} className="mt-2" data-bs-theme="dark" placement='bottom'>
              <Offcanvas.Body>
                <Text style={[styles.text]} >
                  <button className="btn btn-sm btn-outline-warning" title="Close ORGANIZATIONS" onClick={() => clickOrgs(true, false, false)}>Close</button>&nbsp;
                  {orgs
                    .map((item, index) => (
                      <button className={Array.from(filterOrgs).includes(item) ? btnSelectOn : btnSelect} onClick={() => setFilterOrgs([...filterOrgs, item])} key={index}>{item}
                      </button>
                    ))
                  }
                  <button className="btn btn-sm btn-outline-warning" title="Close ORGANIZATIONS" onClick={() => clickOrgs(true, false, false)}>Close</button>&nbsp;
                </Text>
              </Offcanvas.Body>
            </Offcanvas>
            : <span>&nbsp;</span>}
          {locsSelect ?
            <Offcanvas show={locsSelect} className="mt-2" data-bs-theme="dark" placement='bottom' scroll="true" backdrop="true" >
              <Offcanvas.Body>
                <Text style={[styles.text]}>&nbsp;&nbsp;Locs:&nbsp;
                  <button className="btn btn-sm btn-outline-warning" title="Close LOCATIONS" onClick={() => clickLocs(true, false, false)}>Close</button>&nbsp;
                  {locs
                    .sort((a, b) =>
                      (a.toLowerCase() > b.toLowerCase()) ? 1 :
                        ((b.toLowerCase() > a.toLowerCase()) ? -1 : 0))
                    .map((item, index) => (
                      <button className={Array.from(filterLocs).includes(item) ? btnActive : btnNormal} onClick={() => setFilterLocs([...filterLocs, item])} key={index}>{item}
                      </button>
                    ))
                  }
                  <button className="btn btn-sm btn-outline-warning" title="Close LOCATIONS" onClick={() => clickLocs(true, false, false)}>Close</button>&nbsp;
                </Text>
              </Offcanvas.Body>
            </Offcanvas>
            : <span>&nbsp;</span>}
          <div className="row-fluid">
            {(stat2) &&
              <span className="d-flex align-items-center justify-content-center shorttext ">
                {stat2}&nbsp;{stat3}
              </span>
            }
          </div>
        </div>
        : <div><h4 className="stattext">&nbsp;&nbsp;Loading Fresh Master List...</h4></div>}
    </div>
  );
};

export default Talker;


function createStyles(theme) {
  // const styles = {
  //   container: isRowBased ? {flexDirection: 'row' } : {flexDirection: 'column' }
  // };

  return StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: 'column',
      // backgroundColor: 'black',
      // backgroundColor: theme.background,
    },

    textblack: {
      // color: theme.rowtext,
      color: 'white',
      fontSize: '1.1em',
      textAlign: 'left',
      // backgroundColor: theme.rowbg,
      // backgroundColor: 'black',
      // flex: 2,
    },
    text: {
      fontSize: '1.1em',
      textAlign: 'left',
    },
    text1: {
      fontSize: '1.1em',
      fontWeight: 'bold',
      textAlign: 'left',
      space: 'nowrap',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    stathdr: {
      color: 'gold',
      backgroundColor: '#202',
      fontSize: '1.2em',
      textAlign: 'left',
    },

    nametext: {
      color: 'gold',
      fontSize: '1.1em',
      textAlign: 'left',
    },
    linktext: {
      color: 'gold',
      fontSize: '1.4em',
      textAlign: 'left'
    },
    rush: {
      color: 'red',
      fontSize: '1.1em',
      textAlign: 'center',
      // backgroundColor: theme.background,
      backgroundColor: 'white',
    },
    title: {
      // color: theme.header,
      // color: 'orange',
      fontSize: '1.5em',
      fontWeight: 'bold',
      textAlign: 'left',
      // backgroundColor: theme.background,
      // backgroundColor: 'black',
      width: "90%"
    },
    // link: {
    //   // color: theme.text,
    //   color: 'white',
    //   fontSize: 42,
    //   fontWeight: 'bold',
    //   textAlign: 'center',
    //   backgroundColor: 'rgba(16,0,16,0.7)',
    //   textDecorationLine: 'underline',
    // },
    button: {
      height: 40,
      borderRadius: 5,
      padding: 6,
      // backgroundColor: theme.button,
      backgroundColor: 'royalblue',
      justifyContent: 'center',
    },
    butttonText: {
      // color: theme.text,
      color: 'white',
      fontSize: 16,
      fontWeight: 'bold',
      textAlign: 'center',
      verticalAlign: 'middle',
      padding: 4,
    },
    icon: {
      // color: theme.text,
      color: 'white',
      fontSize: 36,
      // backgroundColor: theme.background,
      // backgroundColor: 'black',
      textAlign: 'right',
      verticalAlign: 'middle',
      padding: 1,
      width: '10%'
    },
    viewrow: {
      flexDirection: 'row',
      width: '95%',
    },
    row: {
      height: '100',
      width: '95%',
      flexDirection: 'row',
      marginBottom: 2,
      // backgroundColor: 'rgba(16,0,16,0.7)',
      // borderColor: 'white',
      // borderWidth: 2,
      // borderStyle: 'solid',
      // borderRadius: 5,
    },
    row2: {
      height: '100',
      width: '100%',
      flexDirection: 'row',
      // backgroundColor: 'black',
      marginBottom: 2,
    },
    rowodd: {
      width: '95%',
      // backgroundColor: 'black',
      borderBottomStyle: 'solid',
      borderBottomWidth: '2px',
      borderBottomColor: 'rgba(10, 134, 134, 0.4)',
    },
    roweven: {
      width: '95%',
      // backgroundColor: 'rgba(32,0,32,0.7)',
      borderBottomStyle: 'solid',
      borderBottomWidth: '2px',
      borderBottomColor: 'rgba(134, 101, 10, 0.4)',
    },


    isFail: {
      color: 'red',
      // backgroundColor: 'rgba(32,0,32,0.7)',
      fontSize: '1.2em',
    },

    failCell: {
      color: 'red',
      // backgroundColor: 'rgba(32,0,32,0.7)',
      fontSize: '1.2m',
      width: '15px',
      padding: "0px"
    },

    iconCell: {
      fontSize: '1.2m',
      width: '20px',
      padding: "0px"
    },

    timeCell: {
      color: 'lightgreen',
      fontSize: '0.9m',
      width: '100px',
      padding: "0px"
    },

    timeBase: {
      fontSize: '0.9m',
      width: '100px',
      padding: "0px",
      boxShadow: "none",
      backgroundColor: 'black',
      color: "rgb(13, 202, 240)",
    },

    timeWaiting: {
      color: 'gold',
      fontSize: '0.9m',
      width: '100px',
      padding: "0px"
    },

    timeGood: {
      color: 'lightgreen',
      fontSize: '0.9m',
      width: '100px',
      padding: "0px"
    },

    notContacted: {
      color: 'lightgray',
      // backgroundColor: 'black',
      padding: 0,
      width: '25px',
      fontSize: '.8em',
    },
    contacted: {
      color: 'gold',
      // backgroundColor: 'black',
      padding: 0,
      width: '25px',
      fontSize: '.9em',
    },

    updPhone: {
      // color: theme.header,
      textAlignVertical: "top",
      marginTop: "5px",
      borderRadius: 5,
      padding: "3px",
      color: 'black',
      fontSize: '1.3em',
      textAlign: 'left',
      width: "80%",
      // backgroundColor: theme.background,
      backgroundColor: 'lightgray'
    },
    colTots: {
      color: 'limegreen',
      fontSize: '1.3em'
    },

    sep: {
      height: 3,
      backgroundColor: 'gray',
      width: '50%',
      maxWidth: 400,
      marginHorizontal: 'auto',
      marginBottom: 2,
    },
    apptButon: {
      marginLeft: "15px",
      marginRight: "15px",
    },
    apptBase: {
      borderRadius: "5px",
      borderWidth: "1px",
      boxShadow: "none",
      borderStyle: "solid",
      borderColor: "rgb(13, 202, 240)",
      // backgroundColor: 'black',
      color: "rgb(13, 202, 240)",
    },
    apptWaiting: {
      borderRadius: "5px",
      boxShadow: "none",
      borderStyle: "solid",
      // backgroundColor: 'black',
      borderColor: "gold",
      color: 'gold'
    },
    apptGood: {
      borderRadius: "5px",
      boxShadow: "none",
      borderStyle: "solid",
      // backgroundColor: 'black',
      borderColor: "lightgreen",
      color: 'lightgreen'
    },

    selectTop: {
      position: "fixed",
      marginTop: "150px",
      display: "block",
      zIndex: "200",
      backgroundColor: "black",
      borderColor: "cornflowerblue",
      borderWidth: "3px",
      padding: "5px",
    },

    image: {
      height: '100%',
      width: 'auto',
      flex: 1,
      justifyContent: 'center',
    }
  })
}

